'use client';

import { useEffect, useTransition } from 'react';
import useOptimisticModal from './useOptimisticModal';

const OptimisticModalAutoClose = () => {
  const [_, startTransition] = useTransition();
  const [modalState, updateOptimisticModal] = useOptimisticModal();

  useEffect(
    () => {
      if (modalState && !modalState?.closed) {
        startTransition(() => {
          updateOptimisticModal({ ...modalState, closed: true });

          setTimeout(() => {
            updateOptimisticModal(null);
          }, 10);
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return null;
};

export default OptimisticModalAutoClose;
